import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./Orange_Round_Arrow_Btn.css";
import { Link } from "react-router-dom";

const Orange_Round_Arrow_Btn = ({ onClick, type, baseLink, ...props }) => {
  return (
    <button className="Orange_Round_Arrow_Btn" type={type} onClick={onClick}>
      <p className="btn_text">{props?.btn_name}</p>
      <div className="icon_holder">
        <FontAwesomeIcon icon={faArrowRight} className="right_icon" />
      </div>
    </button>
  );
};

export default Orange_Round_Arrow_Btn;
